<template>
    <div
        class="vm-icon-pay-group flex-box"
        :class="{
            'wechat-env': GL.ENV.is_wechat,
            'alipay-env': GL.ENV.is_alipay,
            'abroad-env': GL.ENV.is_abroad,
        }"
    >
        <icon-pay
            class="mq"
            v-for="item in list"
            :name="item"
            :class="{
                on: pay_type == item,
                disable:
                    (is_enable_disable && GL.ENV.is_wechat && item == 'alipay') ||
                    (GL.ENV.is_alipay && item == 'wxpay') ||
                    (GL.ENV.is_xiaoyuzhou && item == 'wxpay'),
            }"
            :key="item"
            :is_hide_lijian="is_hide_lijian"
            :is_hide_tuijian="is_hide_tuijian"
            :tuijian_type="tuijian_type"
            @click.native="select_pay(item)"
        ></icon-pay>
    </div>
</template>

<script>
export default {
    name: "icon-pay-group",
    props: {
        list: {
            type: Array,
            default: ["alipay"],
        },
        pay_type: {
            type: String,
            default: "",
        },
        tuijian_type: {
            type: String,
            default: "alipay",
        },
        is_enable_disable: {
            type: Boolean,
            default: false,
        },
        is_hide_lijian:{
            default: false,
        },
        is_hide_tuijian:{
          default: false,
        }
    },
    data() {
        return {
            // is_bug_weibo: this.GL.ENV.is_bug_weibo,
            plan_id: this.$route.query.plan_id
        };
    },
    computed: {},
    mounted() {
    },
    methods: {
        select_pay(type) {
            // if (this.is_bug_weibo && type == "wxpay") {
            //     return false;
            // }
            if (this.GL.ENV.is_xiaoyuzhou && type == "wxpay") {
                return false;
            }
            if (!this.GL.ENV.is_wechat && !this.GL.ENV.is_alipay || this.$route.name == 'settingWithdraw') {
                this.$emit("select_pay", { type: type });
            }
        },
    },
};
</script>

<style lang="stylus" scoped>
.vm-icon-pay-group{
    .vm-icon-pay /deep/{
        margin-right: px2rem(48);

        &.wxpay {
            // margin-right: 0;
        }
    }

    @media (max-width: $width-mobile) {
        .vm-icon-pay /deep/{
            // margin-top: px2rem(16);
            margin-right: 0;

            &.alipay {
                // margin-top: 0;
            }
        }

        &.wechat-env {
            .vm-icon-pay /deep/{
                // margin-top px2rem(16)
                margin-top: 0;
                margin-right: 0;

                &.wxpay {
                    margin-top: 0;
                    order: 1;
                }

                &.alipay {
                    // margin-top: px2rem(16);
                    margin-left:8px;
                    order: 2;
                }
            }
        }
    }
}
</style>
